export default "__VITE_ASSET__c8db9f86__"